import React from "react";

import {
  BiHome,
  BiLogOutCircle,
  BiLogInCircle,
  BiCheckDouble,
  BiSave,
  BiRename,
  BiSearchAlt,
  BiRefresh,
  BiEditAlt,
} from "react-icons/bi";
import { BsSpotify, BsCaretUpFill, BsCaretDownFill } from "react-icons/bs";
import {
  FaCaretLeft,
  FaCaretRight,
  FaSortAmountUp,
  FaWindowClose,
  FaCaretSquareDown,
  FaCaretSquareUp,
  FaGripLines,
  FaClipboardCheck,
  FaBlog,
  FaTimes,
  FaExternalLinkAlt,
} from "react-icons/fa";
import { IoMdTrophy, IoMdSettings, IoMdCheckmark } from "react-icons/io";
import {
  MdOutlineBatchPrediction,
  MdWebStories,
  MdOutlineRemoveCircle,
  MdDeleteSweep,
  MdOutlineLocationOn,
  MdCalendarToday,
  MdCancel,
  MdCheckBox,
  MdCheckBoxOutlineBlank,
  MdDownload,
} from "react-icons/md";
import { RiUserSettingsLine, RiUserFill } from "react-icons/ri";
import { VscThreeBars } from "react-icons/vsc";

const icons = {
  app: MdWebStories,
  blog: FaBlog,
  calendar: MdCalendarToday,
  cancel: MdCancel,
  check: IoMdCheckmark,
  checkmark: BiCheckDouble,
  checkbox: MdCheckBox,
  checkboxEmpty: MdCheckBoxOutlineBlank,
  close: FaWindowClose,
  clear: FaTimes,
  delete: MdDeleteSweep,
  down: BsCaretDownFill,
  download: MdDownload,
  drag: FaGripLines,
  home: BiHome,
  left: FaCaretLeft,
  location: MdOutlineLocationOn,
  login: BiLogInCircle,
  logout: BiLogOutCircle,
  moveDown: FaCaretSquareDown,
  moveUp: FaCaretSquareUp,
  name: BiRename,
  nav: VscThreeBars,
  prediction: MdOutlineBatchPrediction,
  profile: RiUserSettingsLine,
  ranking: FaSortAmountUp,
  edit: BiEditAlt,
  external: FaExternalLinkAlt,
  refresh: BiRefresh,
  remove: MdOutlineRemoveCircle,
  right: FaCaretRight,
  save: BiSave,
  search: BiSearchAlt,
  settings: IoMdSettings,
  spotify: BsSpotify,
  submission: FaClipboardCheck,
  trophy: IoMdTrophy,
  up: BsCaretUpFill,
  user: RiUserFill,
};

const IconRender = ({ type, size, ...rest }) => {
  if (!icons[type]) return null;
  return React.createElement(icons[type], {
    size,
    "data-testid": type + "_icon",
    ...rest,
  });
};

export default IconRender;
